import React from 'react';
import { formatDateForDisplay } from '../../../../utils/utils';
import * as ArchivedRenewalBucket from '../../../../constants/ArchivedRenewalBucket';
import CompletedRenewalsActions from '../CompletedRenewalsPortalPage/CompletedRenewalsActions';

const formatRenewalClassification = (props, classification) =>
  props.intl.formatMessage({
    id: !!ArchivedRenewalBucket[classification]
      ? ArchivedRenewalBucket[classification].display
      : 'no_classification'
  });

const completedRenewalsColumns = (props) => [
  {
    header: {
      display: props.intl.formatMessage({ id: 'customer_number' }),
      sortBy: 'deliverToCustomerNumber'
    },
    accessor: (archivedRenewal) => ({
      display: archivedRenewal.deliverToCustomerNumber
    })
  },
  {
    header: {
      display: props.intl.formatMessage({ id: 'customer_name' }),
      sortBy: 'deliverToCustomerName'
    },
    accessor: (archivedRenewal) => ({
      display: archivedRenewal.deliverToCustomerName
    })
  },
  {
    header: {
      display: props.intl.formatMessage({ id: 'completed' }),
      sortBy: 'customerApproveDate'
    },
    accessor: (archivedRenewal) => ({
      display: formatDateForDisplay(archivedRenewal.customerApproveDate)
    })
  },
  {
    header: {
      display: props.intl.formatMessage({ id: 'branch_code' }),
      sortBy: 'branchCode'
    },
    accessor: (archivedRenewal) => ({
      display: archivedRenewal.branchCode
    })
  },
  {
    header: {
      display: props.intl.formatMessage({ id: 'route_CSR' }),
      sortBy: 'routeNumber'
    },
    accessor: (archivedRenewal) => {
      return {
        display: `${archivedRenewal.routeNumber} / ${archivedRenewal.csrName}`
      };
    }
  },
  {
    header: {
      display: props.intl.formatMessage({ id: 'proposed_by' })
    },
    accessor: (archivedRenewal) => {
      return {
        display: `${archivedRenewal.proposedBy}`
      };
    }
  },
  {
    header: {
      display: props.intl.formatMessage({ id: 'district_code' }),
      sortBy: 'code'
    },
    accessor: (archivedRenewal) => {
      return {
        display: archivedRenewal.code
      };
    }
  },
  {
    header: {
      display: props.intl.formatMessage({ id: 'bucket' }),
      sortBy: 'classification'
    },
    accessor: (archivedRenewal) => ({
      display: formatRenewalClassification(props, archivedRenewal.classification)
    })
  },
  {
    header: {
      display: props.intl.formatMessage({ id: 'completed_renewal_actions' })
    },
    accessor: (archivedRenewal) => ({
      display: <CompletedRenewalsActions archivedRenewal={archivedRenewal} />
    })
  }
];

export default completedRenewalsColumns;
